import { useMemo } from "react";
const INDIANA_CHARGER_STATION_NAME = "indiana charger station";
const CHARGING_STATION_TYPE = "CHARGING_STATION";
export const isIndianaChargerStation = (assetName, assetSourceType) => assetName?.trim().toLowerCase() === INDIANA_CHARGER_STATION_NAME &&
    assetSourceType?.trim().toUpperCase() === CHARGING_STATION_TYPE;
export const useIsIndianaChargerStationFlag = (assetName, assetSourceType) => {
    return useMemo(() => isIndianaChargerStation(assetName, assetSourceType), [assetName, assetSourceType]);
};
